import {
	SET_FORM_STATE
} from '../actions/CellInfoActions.js';

const initialState = {
	formState: {
		techAdd: {
			isValid: false,
			values: {
				inputType: 'file'
			},
			touched: {},
			errors: {},
		},
		cellInfo: {
			isValid: false,
			values: {
				inputType: 'file'
			},
			touched: {},
			errors: {},
		}
	},
	openAddProjectDialog: false,
	templates: []
};

const cellInfoReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default cellInfoReducer;
